import React, { Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useForm, Controller } from "react-hook-form"

import FieldText from '../components/FieldText'
import FieldSelect from '../components/FieldSelect'
import { selectors as appSelectors } from '../features/app'
import { actionTypes, selectors } from '../features/vehicle'
import ReCAPTCHA from "react-google-recaptcha";
import FieldCaptcha from '../components/FieldCaptcha'
import _ from 'lodash'
import ErrorSummary from '../components/ErrorSummary'
import { AnalyticElement, AnalyticType } from '../types.d'

interface StartValues {
  handleAnalyticEvent: Function, 
  handleStartSubmit: Function
}
const Start: React.FC<StartValues> = ({ handleAnalyticEvent, handleStartSubmit }) => {
  type FormData = {
    auststate: string;
    rego: string;
    kms: string;
    captcha: string
  };

  const dispatch = useDispatch();
  const disabled = useSelector(appSelectors.getAppIsLoading);
  const auststate = useSelector(selectors.getVehicleAustState);
  const kms = useSelector(selectors.getVehicleKms);
  const rego = useSelector(selectors.getVehicleRego);
  const { handleSubmit, control, trigger, formState: { errors } } = useForm<FormData>({
    defaultValues: {
      auststate, 
      rego,
      kms
    }
  });
  const handleFieldFocus = (name: string) => {
    // handleAnalyticEvent({
    //   type: AnalyticType.Focus, 
    //   element: AnalyticElement.Field,
    //   name
    // });
  };
  const handleButtonClick = (name: string) => {
    handleAnalyticEvent({
      type: AnalyticType.Click, 
      element: AnalyticElement.Button,
      name
    });
  };
  const onSubmit = (data: FormData) => {
    dispatch({ type: actionTypes.SET_VEHICLE, payload: data });
    handleStartSubmit(data.rego, data.auststate, data.captcha);
  };

  const states = [
    {label: "NSW", value: "NSW" },
    {label: "QLD", value: "QLD" },
    {label: "SA", value: "SA" },
    {label: "TAS", value: "TAS" },
    {label: "VIC", value: "VIC" },
    {label: "WA", value: "WA" },
    {label: "ACT", value: "ACT" },
    {label: "NT", value: "NT" },
  ] 

  return (
    <Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled}>
          <div className="i-row">
              <div className="i-col">
                <Controller control={control}
                  name="auststate"
                  rules={{ required: 'State is required' }}  
                  render={({ field: { onChange, name, ref } }) => {
                    const handleSelectChange = (selectedOption: any | null) => {
                      onChange(selectedOption?.value);
                    };
                    const defaultValueArray = states.filter(o => o.value == auststate);
                    const defaultValue = defaultValueArray.length ? defaultValueArray[0] : {label: 'State', value: ''}
                    return <FieldSelect 
                      name={name}
                      inputRef={ref}
                      defaultValue={defaultValue}
                      options={states}
                      error={errors.auststate}
                      onFocus={() => handleFieldFocus('State')}
                      onChange={handleSelectChange}
                    />
                  }}
                />
              </div>
              <div className="i-col">
                <Controller control={control}
                  name="rego"
                  rules={{ required: 'Rego is required', pattern: {value: /^[a-zA-Z0-9]{1,7}$/, message: 'Rego is not valid'} }}  
                  render={({ field: { onChange, value, name, ref } }) => {
                    const handleFieldChange = (e: any | null) => {
                      e.target.value = e.target.value.toUpperCase();
                      onChange(e);
                    };
                    return <FieldText 
                      defaultValue={rego}
                      name={name} 
                      inputRef={ref}
                      label="Registration No." 
                      error={errors.rego} 
                      maxlength={7}
                      onChange={handleFieldChange}
                    />
                  }} 
                />
              </div>
          </div>
          <Controller control={control}
            name="kms"
            rules={{ required: 'Kilometres is required', pattern: {value: /\b[1-9]\d{0,4}\b|\b1\d{0,5}\b/g, message: 'This must be less than 200,000'} }}  
            render={({ field: { onChange, value, name, ref } }) => {
              const handleFieldChange = (e: any | null) => {
                onChange(e);
              };
              return <FieldText 
                type="number"
                defaultValue={kms.toString()}
                name={name} 
                inputRef={ref}
                label="Enter your kms" 
                error={errors.kms} 
                onChange={handleFieldChange}
              />
            }} 
          />
          <div className='i-form-group'>
            <Controller control={control}
              name="captcha"
              rules={{ required: 'Captcha is required' }}  
              render={({ field: { onChange, name, ref } }) => {
                const onRecaptchaChange = (v: any | null) => {
                  onChange(v);
                };
                return <FieldCaptcha 
                  sitekey="6LdzrHoaAAAAAPkeBdkuL5WqGsE7JZwf-96ZLCXZ"
                  onChange={onRecaptchaChange}
                  error={errors.captcha}
                />
              }}
            />
          </div>
          <div className="i-text-group">
              <p>Your car must be less than 10 years old and have completed less than 200,000km to be eligible for a&nbsp;valuation.</p>
          </div>
          {/* <ErrorSummary errors={errors} /> */}
          <div className="i-button-group">
            <button type="submit" 
              className="button-outline" 
              disabled={disabled}
              onClick={() => handleButtonClick('Continue')}>
              <span>Continue</span>
            </button>
        </div>
        </fieldset>
      </form>
    </Fragment>
  )
}

export default Start;